import React, { FC, HTMLAttributes, ReactNode } from 'react';

export interface TableProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const Table: FC<TableProps> = ({ children }: TableProps) => {
  return (
    <div className="py-6 bg-white shadow-thryv rounded-sm">{children}</div>
  );
};
